import React, { Component } from 'react';

import axios from 'axios';
let FactAuthEmailResendTimeout, FactAuthSMSResendTimeout;



export default class OTPUIComp extends Component {


    constructor(props) {
        super(props);
        
       
        this.state =
        {
            OTPTxt: "",
            OTPSubmitErr: "",


            FactorAuthEmailOTP: "",
            FactorAuthSMSOTP: "",
            LoginOtp: "",
           
            enableFactorAuthEmailOTPResend: false,
            enableFactorAuthSMSOTPResend: false,

            showFrgtPwd: (props.Settings.SendOTPForForgotPwdThrough || ""),
            showFactorAuth: (props.Settings.Enable2FactorAuth || ""),


            invalidOTPAttempts: 0,
        }

    }

    handleKeyUp(event, eventVal) {
        event.preventDefault()
        if (event.keyCode === 13) {
            switch (eventVal) {
                case 'FrgtPwdClick':
                    this.props.FrgtPwdClick(event)
                    break
                case 'close':
                    this.closeFrgtPwdPopup(event)
                    break
                case 'OTPSubmit':
                    this.OTPSubmitClick(event)
                    break
                case 'FrgtPwdResendClick':
                    this.props.FrgtPwdResendClick(event)
                    break
                case 'EmailOTPResend':
                    this.FactorAuthOTPResendClick(event, "E")
                    break
                case 'SMSOTPResend':
                    this.FactorAuthOTPResendClick(event, "S")
                    break
                case 'closeFactorAuth':
                    this.closeFactorAuthPopup(event)
                    break
            }
        }
    }

    retainTabIndex(e) {
        e.preventDefault()
        if (e.keyCode == 9) {

            this.refs.FrgtPwdOTP.focus()


            if (this.state.showFactorAuth.search("E") > -1) {
                this.refs.FactorAuthEmailOTP.focus()
            } else if (this.state.showFactorAuth.search("S") > -1) {
                this.refs.FactorAuthSMSOTP.focus()
            }

        }
    }

    FactorAuthOTPResendClick(event, type) {
        event.preventDefault()
        let { enableFactorAuthEmailOTPResend, enableFactorAuthSMSOTPResend } = this.state
        if ((type === "E") && (enableFactorAuthEmailOTPResend)) {
            this.CallFactorAuthOTPService(type)
        }
        if ((type === "S") && (enableFactorAuthSMSOTPResend)) {
            this.CallFactorAuthOTPService(type)
        }
    }

    FactorAuthEmailOTPChange(event) {

        event.preventDefault()
        this.setState({
            FactorAuthEmailOTP: event.target.value
        })

        this.setState({
            LoginOtp: event.target.value
        })

    }

    FactorAuthSMSOTPChange(event) {

        event.preventDefault()
        this.setState({
            FactorAuthSMSOTP: event.target.value
        })


        this.setState({
            LoginOtp: event.target.value
        })

    }

    bypassOTPWindow () {
        // Logic to proceed without OTP verification, e.g., calling the next step
        if (this.props.onSuccess) {
            this.props.onSuccess(); // Or any other function to proceed
        }
    }




    CallFactorAuthOTPService(type) {
        let { UserIdTxt } = this.props.LoginForm.state
        let webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/GenerateAndSendOTPForAuth';

        axios({
            url: webMethodUrl,
            method: "POST",
            data: { UserID: UserIdTxt, SettingValue: type },
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })

        if (type.search("E") > -1) {

            if (this.refs.FactorAuthEmailOTP) {
                this.refs.FactorAuthEmailOTP.focus();
            }

            this.setState({
                enableFactorAuthEmailOTPResend: false
            }, () => {
                if (FactAuthEmailResendTimeout) {
                    clearTimeout(FactAuthEmailResendTimeout);
                }
                FactAuthEmailResendTimeout = setTimeout(() => {
                    this.setState({
                        enableFactorAuthEmailOTPResend: true,
                    })
                }, 60000)
            })
        }

        if (type.search("S") > -1) {

            if (type.search("E") > -1) {
                if (this.refs.FactorAuthEmailOTP) {
                    this.refs.FactorAuthEmailOTP.focus();
                }
            } else {
                if (this.refs.FactorAuthSMSOTP) {
                    this.refs.FactorAuthSMSOTP.focus();
                }
            }


            this.setState({
                enableFactorAuthSMSOTPResend: false
            }, () => {
                if (FactAuthSMSResendTimeout) {
                    clearTimeout(FactAuthSMSResendTimeout);
                }
                FactAuthSMSResendTimeout = setTimeout(() => {
                    this.setState({
                        enableFactorAuthSMSOTPResend: true,
                    })
                }, 60000)
            })
        }
    }
    OTPSubmitClick(event) {
       
        event.preventDefault()



        let { UserIdTxt } = this.props.LoginForm.state;
        let { FactorAuthEmailOTP, FactorAuthSMSOTP, showFactorAuth } = this.state

        FactorAuthEmailOTP.trim()
        FactorAuthSMSOTP.trim()

        let isProceedEnabled
       
        if ((showFactorAuth === "ES") && (FactorAuthEmailOTP.length > 5) && (FactorAuthSMSOTP.length > 5)) {
            isProceedEnabled = true
        } else if ((showFactorAuth === "E") && (FactorAuthEmailOTP.length > 5)) {
            isProceedEnabled = true
        } else if ((showFactorAuth === "S") && (FactorAuthSMSOTP.length > 5)) {
            isProceedEnabled = true
        } else {
            isProceedEnabled = false
        }


      
        if (isProceedEnabled) {

            let webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/VerifyOTPForAuth';
    
            axios({
                url: webMethodUrl,
                method: "POST",
                data: { EmailOTP: FactorAuthEmailOTP, SMSOTP: FactorAuthSMSOTP, UserID: UserIdTxt },
                headers: { 'Content-Type': 'application/json;charset=UTF-8' }
            })
                .then((res) => {
                    if (res) {
                        if (res.data.d.Status === true) {

                            this.setState({
                                OTPSubmitErr: "",
                                ErrMsg: "",
                                FactorAuthEmailOTP: "",
                                FactorAuthSMSOTP: "",
                                enableFactorAuthEmailOTPResend: false,
                                enableFactorAuthSMSOTPResend: false,
                            }, () => {
                                if (this.props.onSuccess)
                                    this.props.onSuccess()

                            })

                        } else if (res.data.d.ErrorMsg) {
                            this.setState({
                                OTPSubmitErr: (res.data.d.ErrorMsg.length > 0) ? res.data.d.ErrorMsg : 'Something Went Wrong'
                            })
                        } else {
                            this.handleUnknownError()
                        }
                    } else {
                        this.handleUnknownError()
                    }
                })
                .catch(() => {

                    this.handleUnknownError()

                })

        }




        let { OTPTxt } = this.state
        var isAdmin = this.props.loginInfo.UserRole == "ADMIN";
       
        
        if (OTPTxt.trim().length > 5) {

           
            if (this.props.twofactorAuth) {
               
                fetch(window.baseUrl + 'Login/LoginAuth', {
                    method: 'POST', // or 'POST'
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ Otp: OTPTxt, UserID: UserIdTxt, IsAdmin: isAdmin }),
                })
                    .then(response => {
                        

                        if (response.redirected) {
                            window.location = response.url;
                            return;
                        }
                        return response.json()
                    })
                    .then(repdata => {
                       

                        if (repdata) {


                            if (repdata.status) {
                                //this.props.onSuccess();


                                if (this.props.Parent.refs.ProceedForm)
                                    this.props.Parent.refs.ProceedForm.showLoginDetailsWindow(this.props.loginInfo, () => { this.props.Parent.forceUpdate(); })

                                this.setState({
                                    OTPTxt: "",
                                    OTPSubmitErr: "",
                                    ErrMsg: "",
                                })
                            } else {
                                this.setState({
                                    OTPSubmitErr: (repdata.message)
                                })
                            }


                        }
                    })
                    .catch((error) => {
                        this.setState({ disableButtons: false });
                        alert('error:' + error);
                        console.error('Error:', error);
                    });
            } else {
                let webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/VerifyOTP';

                axios({
                    url: webMethodUrl,
                    method: "POST",
                    data: { OTP: OTPTxt, UserID: UserIdTxt, SessionKey: "" },
                    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
                })
                    .then((res) => {
                        if (res) {
                            if (res.data.d.Status === true) {
                                this.setState({
                                    OTPTxt: "",
                                    OTPSubmitErr: "",
                                    ErrMsg: "",
                                }, () => { this.props.LoginForm.showNewPWD(true) })

                            } else if (res.data.d.ErrorMsg) {
                                this.setState({
                                    OTPSubmitErr: (res.data.d.ErrorMsg.length > 0) ? res.data.d.ErrorMsg : 'Something Went Wrong'
                                })
                            } else {
                                this.handleUnknownError()
                            }
                        } else {
                            this.handleUnknownError()
                        }
                    })
                    .catch(() => {

                        this.handleUnknownError()

                    })
            }
        }


    }

    onOTPTxtChange(event) {
        event.preventDefault()
        this.setState({
            OTPTxt: event.target.value
        })
    }

    handleUnknownError() {
        this.setState({
            OTPSubmitErr: 'Something Went Wrong'
        })
    }

    closeFactorAuthPopup(event) {
        event.preventDefault()

        this.setState({
            OTPTxt: "",
            OTPSubmitErr: '',
            FactorAuthEmailOTP: "",
            FactorAuthSMSOTP: "",
            enableFactorAuthEmailOTPResend: false,
            enableFactorAuthSMSOTPResend: false,
        }, () => {
            if (this.props.onClose)
                this.props.onClose()
        })
    }

    closeFrgtPwdPopup(event) {
        event.preventDefault()
        this.setState({
            FactorAuthEmailOTP: "",
            FactorAuthSMSOTP: "",
            enableFactorAuthEmailOTPResend: false,
            enableFactorAuthSMSOTPResend: false,
            OTPTxt: "",
            OTPSubmitErr: '',
        }, () => {
            this.props.Screen.OTPWin = false;
            this.props.Screen.FPOTPWin = false;
            this.props.Parent.forceUpdate(); if (this.refs.txtUserId) this.refs.txtUserId.focus()
        })
    }

    render() {

        let { showFrgtPwd, showFactorAuth,
            OTPTxt, FactorAuthEmailOTP, FactorAuthSMSOTP } = this.state


        let registeredES = ""
        let submitButtonText = ""
        let enableSubmitButton = false
        let shouldPopupHeightChange = false


        submitButtonText = "PROCEED"

        if (showFactorAuth === "ES") {
            registeredES = 'Email Id and Mobile Number'
            shouldPopupHeightChange = true
            if ((FactorAuthEmailOTP.length > 5) && (FactorAuthSMSOTP.length > 5)) {
                enableSubmitButton = true
            }
        } else if (showFactorAuth === "E") {
            registeredES = 'Email Id'
            if (FactorAuthEmailOTP.length > 5) {
                enableSubmitButton = true
            }
        } else if (showFactorAuth === "S") {
            registeredES = 'Mobile Number'
            if (FactorAuthSMSOTP.length > 5) {
                enableSubmitButton = true
            }
        } else if (showFactorAuth === "Authenticator") {
            registeredES = 'Authenticator'
            if (FactorAuthSMSOTP.length > 5) {
                enableSubmitButton = true
            }
        }





        submitButtonText = "GO"
        if (showFactorAuth === 'Authenticator') {
            registeredES = 'Authenticator app'
           
        }
         else if (showFrgtPwd === 'SMS') {
            registeredES = 'Mobile Number'
        } else if (showFrgtPwd === 'Email') {
            registeredES = 'Email Id'
           
        } 

        if (OTPTxt.length > 5) {
            enableSubmitButton = true
        }


        return (<div className="FrgtPwdPopup-fixed">
            <div className={shouldPopupHeightChange && "FactorAuthPopup-fixed"}>
                <div>
                    <div className='OTP-validation-form'>
                        <div tabIndex='1' onKeyDown={(e) => this.retainTabIndex(e)} onKeyUp={(e) => this.retainTabIndex(e)}>
                            {registeredES === "Authenticator"

                                ? <p>OTP is displayed on your {registeredES}.</p>
                                : <p>OTP has been sent to your registered {registeredES}.</p>
                            }
                        </div>
                        <div className={shouldPopupHeightChange && 'FactorAuth-validation-form'}>
                            <form onSubmit={(event) => this.OTPSubmitClick(event)}>
                                {this.props.FPOTPWin ?
                                    <div className='OTP-input-grid'>
                                        <input type='text' ref="FrgtPwdOTP" className='userid1' placeholder="Enter OTP" tabIndex='1'
                                            value={this.state.OTPTxt} onChange={(event) => this.onOTPTxtChange(event)}
                                            maxLength="6" />
                                        <div>
                                            <div tabIndex='1' onClick={(event) => this.props.FrgtPwdResendClick(event)} className={this.props.enableResend ? "FrgtPwdResend-on" : "FrgtPwdResend-off"}
                                                onKeyUp={(event) => this.handleKeyUp(event, "FrgtPwdResendClick")} >Resend</div>
                                        </div>
                                    </div> : null}


                                <div>
                                    {(showFactorAuth.search("E") > -1) &&
                                        <div className='OTP-input-grid'>
                                            <input type='text' ref="FactorAuthEmailOTP" className='userid1' placeholder="Enter Email OTP" tabIndex='1'
                                                value={this.state.FactorAuthEmailOTP} onChange={(event) => this.FactorAuthEmailOTPChange(event)}
                                                maxLength="6" />
                                            <div>
                                                <div tabIndex='1' onClick={(event) => this.FactorAuthOTPResendClick(event, "E")}
                                                    className={this.state.enableFactorAuthEmailOTPResend ? "FrgtPwdResend-on" : "FrgtPwdResend-off"}
                                                    onKeyUp={(event) => this.handleKeyUp(event, "EmailOTPResend")} >Resend</div>
                                            </div>
                                        </div>
                                    }
                                    {(showFactorAuth.search("S") > -1) &&
                                        <div className='OTP-input-grid'>
                                            <input type='text' ref="FactorAuthSMSOTP" className='userid1' placeholder="Enter SMS OTP" tabIndex='1'
                                                value={this.state.FactorAuthSMSOTP} onChange={(event) => this.FactorAuthSMSOTPChange(event)}
                                                maxLength="6" />
                                            <div>
                                                <div tabIndex='1' onClick={(event) => this.FactorAuthOTPResendClick(event, "S")}
                                                    className={this.state.enableFactorAuthSMSOTPResend ? "FrgtPwdResend-on" : "FrgtPwdResend-off"}
                                                    onKeyUp={(event) => this.handleKeyUp(event, "SMSOTPResend")} >Resend</div>
                                            </div>
                                        </div>
                                    }

                                    

                                </div>

                                {(this.state.OTPSubmitErr.length > 0) ? <div className='msg1'>{this.state.OTPSubmitErr}</div> :
                                    <div className='msg1 msg-invisible'>Error will be displayed here.</div>
                                }
                                <div className='OTP-submit'>
                                    <div></div>
                                    <div>
                                        <a onClick={(event) => this.OTPSubmitClick(event)}
                                            tabIndex="1" onKeyUp={(event) => this.handleKeyUp(event, 'OTPSubmit')}>
                                            <input type='submit' value={submitButtonText} tabIndex="-1"
                                                className={enableSubmitButton ? "form1-bu" : "form1-bu-d"} style={{ width: '100%' }} />
                                        </a>
                                        <div className="form1-bu" tabIndex="1" style={{ width: '100%', textAlign: 'center' }}
                                            onClick={(event) => this.closeFactorAuthPopup(event)}
                                            onKeyUp={(event) => this.handleKeyUp(event, 'closeFactorAuth')} >
                                            CANCEL <span tabIndex="1" onKeyDown={(e) => this.retainTabIndex(e)} onKeyUp={(e) => this.retainTabIndex(e)} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>)


    }
}
